<template>
  <span class="ui-input" :class="$attrs.class">
    <span class="ui-input--title" v-if="title">{{ title }}</span>
    <span class="flex items-center">
      <component
        :is="textarea ? 'textarea' : 'input'"
        v-bind="{ ...$attrs, class: inputClassComputed }"
        :type="textarea ? undefined : (type ?? 'text')"
        :value="modelValue"
        @input="handleInput"
      />
      <span class="ui-input--append" v-if="appendText">{{ appendText }}</span>
    </span>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  modelValue: string | number
  type?: string
  inputClass?: string
  title?: string
  appendText?: string
  textarea?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number): void
}>()

const inputClassComputed = computed(() => {
  return [
    'w-full',
    props.textarea ? 'min-h-[120px] py-3 px-4 rounded-[24px]' : 'h-[48px] px-6 rounded-full',
    'text-standard leading-6 text-black placeholder-gray-600 border border-gray-300 focus:outline-none focus:border-primary-blue transition duration-200',
    props.inputClass || '',
  ].join(' ')
})

function handleInput(event: Event) {
  const value = (event.target as HTMLInputElement | HTMLTextAreaElement).value
  if (props.type === 'number') {
    const parsed = Number(value)
    emit('update:modelValue', isNaN(parsed) ? '' : parsed)
  } else {
    emit('update:modelValue', value)
  }
}
</script>

<style scoped lang="scss">
.ui-input {
  .ui-input--title {
    display: block;
    margin-bottom: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
    letter-spacing: -0.02em;
    color: #000000;
  }

  .ui-input--append {
    margin-left: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
    letter-spacing: -0.02em;
    color: #a1a1a1;
  }

  textarea {
    resize: none;
  }
}
</style>
